// Lib
import React from 'react';

// Components
import ArrowTool from './ArrowTool';

const EndArrowTool = (props) => <ArrowTool {...props} styleProp="endStyle" iconDirection="right" />;

export default EndArrowTool;
